// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ChatPage.test.tsx
import { type ReactNode } from "react";

import { AskV2ReviewEmailNotificationBanner } from "./AskV2ReviewEmailNotificationBanner";

type AskV2ThreadComposerStackProps = {
  chatId: string | null | undefined;
  reviewInProgress: boolean;
  children: ReactNode;
};

export function AskV2ThreadComposerStack({
  chatId,
  reviewInProgress,
  children,
}: AskV2ThreadComposerStackProps) {
  return (
    <div
      className="flex w-full flex-col gap-2"
      data-testid="ask-v2-thread-composer-stack"
    >
      {chatId ? (
        <AskV2ReviewEmailNotificationBanner
          chatId={chatId}
          reviewInProgress={reviewInProgress}
        />
      ) : null}
      {children}
    </div>
  );
}
